import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GetInventoryPurchase } from "../models/inventoryPurchases/getInventoryPurchasesDto";
import {
  AddInventoryPurchasePOHeaderWithLineDto,
  InventoryPurchaseOrderHeaderAddressDto,
} from "../models/inventoryPurchases/InventoryPurchaseHeaderLineDto";
import { AddAndUpdateFinishedGoodsTemplateDto } from "../models/inventoryPurchases/addAndUpdateFinishedGoodsTemplateDto";
import { GetFinishedGoodTemplateDto } from "../models/inventoryPurchases/getFinishedGoodTemplateDto";
import { FinishedGoodsTemplateHeader } from "../models/inventoryPurchases/finishedGoodsTemplateHeader";
import { DeleteTemplateDto } from "../models/inventoryPurchases/deleteTemplateDto";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { GenericRequestDto } from "../models/generic-request.dto";
import { PurchaseOrderLine } from "../models/samplePO/details/purchaseOrderLine";
import { AddInventoryPurchaseHeader } from "../models/cdi/AddInventoryHeader.dto";

@Injectable({
  providedIn: "root",
})
export class InventoryPurchaseService {
  private samplePurchaseOrderBaseUrl =
    environment.baseUrl + "/SamplePOMangement";

  // private vendorInfoBaseUrl =
  //   environment.baseUrl + '/Common/GetAddressesByPartyNumberAndAccountNumber';

  constructor(private _http: HttpClient) {}

  getAllInventoryPO(
    request: GenericRequestDto
  ): Observable<GenericResponseDto<GetInventoryPurchase[]>> {
    return this._http.post<GenericResponseDto<GetInventoryPurchase[]>>(
      `${this.samplePurchaseOrderBaseUrl}/GetAllInventoryPO`,
      request
    );
  }

  getInventoryPOSummary(
    poNumber: string
  ): Observable<GenericResponseDto<InventoryPurchaseOrderHeaderAddressDto>> {
    return this._http.get<
      GenericResponseDto<InventoryPurchaseOrderHeaderAddressDto>
    >(
      `${this.samplePurchaseOrderBaseUrl}/GetInventoryPurchaseHeader?samplePONumber=${poNumber}`
    );
  }

  getAllChildPo(
    purchaseOrderNumber: string
  ): Observable<GenericResponseDto<string[]>> {
    return this._http.get<GenericResponseDto<string[]>>(
      `${this.samplePurchaseOrderBaseUrl}/GetAllChildPo?purchaseOrderNumber=${purchaseOrderNumber}`
    );
  }

  // getVendorInformation(
  //   partyNumber: string,
  //   accountNumber: string
  // ): Observable<GenericResponseDto<any[]>> {
  //   return this._http.get<GenericResponseDto<any[]>>(
  //     `${this.samplePurchaseOrderBaseUrl}?partyNumber=${partyNumber}&accountNumber=${accountNumber}`
  //   );
  // }

  getInventoryPurchaseLines(purchaseOrderNumber: string) {
    return this._http.get<GenericResponseDto<PurchaseOrderLine[]>>(
      `${this.samplePurchaseOrderBaseUrl}/GetAllD365InventoryLines?samplePONumber=${purchaseOrderNumber}`
    );
  }

  getFinishedGoodsTemplateNames() {
    return this._http.get<GenericResponseDto<FinishedGoodsTemplateHeader[]>>(
      `${this.samplePurchaseOrderBaseUrl}/GetFinishedGoodsTemplateNames`
    );
  }

  getFinishedGoodsTemplate(templateId: number) {
    return this._http.get<GenericResponseDto<GetFinishedGoodTemplateDto>>(
      `${this.samplePurchaseOrderBaseUrl}/GetFinishedGoodsTemplate?id=${templateId}`
    );
  }

  addInventoryPO(payload: AddInventoryPurchasePOHeaderWithLineDto) {
    return this._http.post<GenericResponseDto<AddInventoryPurchaseHeader>>(
      `${this.samplePurchaseOrderBaseUrl}/AddInventoryPurchaseOrderHeader`,
      payload
    );
  }

  updateInventoryPO(payload: AddInventoryPurchasePOHeaderWithLineDto) {
    return this._http.put<
      GenericResponseDto<AddInventoryPurchasePOHeaderWithLineDto>
    >(`${this.samplePurchaseOrderBaseUrl}/UpdatePurchaseOrderHeader`, payload);
  }

  addAndUpdateFinishedGoodsTemplate(
    payload: AddAndUpdateFinishedGoodsTemplateDto
  ) {
    return this._http.post<GenericResponseDto<number>>(
      `${this.samplePurchaseOrderBaseUrl}/AddAndUpdateFinishedGoodsTemplate`,
      payload
    );
  }

  deleteTemplate(payload: DeleteTemplateDto) {
    return this._http.post<GenericResponseDto<boolean>>(
      `${this.samplePurchaseOrderBaseUrl}/DeleteTemplate`,
      payload
    );
  }
}
